import React, { useCallback, useEffect, useState } from "react";
import Accreditation from "./aboutUsSubTabs/Accreditation";
import OurPurpose from "./aboutUsSubTabs/OurPurpose";
import OurTeam from "./aboutUsSubTabs/OurTeam";
import ComponentListSubTabsComponent from "./subTabs/ComponenListSubTabs";
import "./aboutUs.scss";
import { useDispatch } from "react-redux";
import { updateAboutUsKey } from "../../../Reducer/localStorageSlice";
import { useSelector } from "react-redux";

export default function AboutUsComponent({ ChangeShowDetailHandler, missingTabs }) {
    const [aboutUsKey, setAboutUsKey] = useState('ABOUT_US');
    const dispatch = useDispatch()
    const localData = useSelector((state) => state?.localStorage)
    const { aboutUsKey: localStorageAboutUsKey, tabConfigId } = localData

    const changeAboutUsTab = (tabValue) => {
        setAboutUsKey(tabValue)
        dispatch(updateAboutUsKey(tabValue))
    }

    const subTabs = useCallback(()=>{
        return [
                {
                    title: 'Our Purpose',
                    key: 'ABOUT_US',
                    component: <OurPurpose activeKey={aboutUsKey} />
                },
                {
                    title: 'Our Story',
                    key: 'OUR_STORY',
                    component: <OurPurpose activeKey={aboutUsKey} />
                },
                {
                    title: 'Our Team',
                    key: 'OUR_TEAM',
                    component: <OurTeam activeKey={aboutUsKey} />
                },
                {
                    title: 'Our Clients',
                    key: 'OUR_CLIENT',
                    component: <OurTeam activeKey={aboutUsKey} />
                },
                {
                    title: 'Accreditations',
                    key: 'ACCREDITATIONS_AWARDS',
                    component: <Accreditation activeKey={aboutUsKey} />
                },
            ]?.filter((d)=> {
                if(missingTabs?.length){
                    return !missingTabs?.some((m)=> m === d?.key)
                }
                return true
            })
    },[aboutUsKey, missingTabs])


    useEffect(() => {
        let tabVal = localStorageAboutUsKey
        if (tabVal) {
            // debugger
            setAboutUsKey(tabVal);
        }
        else{
            const subTabsLocal = subTabs()
            const key = subTabsLocal?.[0]?.key
            if(key){
                setAboutUsKey(key)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorageAboutUsKey, subTabs]);

    return (
        <>
            <ComponentListSubTabsComponent data={subTabs() || []} activeKey={aboutUsKey} handleSubTabChange={changeAboutUsTab} />
        </>
    );
}

